import React from 'react';
import PropTypes from 'prop-types';
import {Button, Input, Modal, ModalHeader, ModalBody, ModalFooter, Collapse} from 'reactstrap';
import {countBy} from 'lodash';
import moment from 'moment';
import TextBoxControl from "../Common/TextBoxControl";
import {isNullEmptyOrWhitespace, IsNullOrUndefined} from "../../constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {dateFormat} from "./ClosedPeriodsView";
import CheckBoxControl from "../Common/CheckBoxControl";

class ClosedPeriodView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      closedPeriod: props.closedPeriod,
      validationMessages: {},
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleOnChangeDate = this.handleOnChangeDate.bind(this);
    this.handleOnSave = this.handleOnSave.bind(this);
    this.validate = this.validate.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {closedPeriod} = this.props;
    let prevClosedPeriod = prevProps.closedPeriod;

    if (IsNullOrUndefined(prevClosedPeriod) && !IsNullOrUndefined(closedPeriod) && IsNullOrUndefined(this.state.closedPeriod)) {
      this.setState({closedPeriod});
    } else if (!IsNullOrUndefined(prevClosedPeriod) && !IsNullOrUndefined(closedPeriod) && closedPeriod.id !== prevClosedPeriod.id) {
      this.setState({closedPeriod});
    } else if (!IsNullOrUndefined(prevClosedPeriod) && IsNullOrUndefined(closedPeriod)) {
      this.setState({closedPeriod});
    }
  }

  handleFieldChange(e) {

    let {closedPeriod} = this.state;

    if(e.target.type==='checkbox'){
      closedPeriod[e.target.name] = e.target.checked;
    } else {
      closedPeriod[e.target.name] = e.target.value;
    }

    this.setState({
      closedPeriod,
    }, this.validate);
  }

  handleOnChangeDate(date, name) {
    let {closedPeriod} = this.state;

    closedPeriod[name] = IsNullOrUndefined(date) ? '' : date.format(dateFormat);

    if(name === 'dateFrom' && moment(closedPeriod.dateFrom).isBefore(moment(), 'day') && closedPeriod.id > 0){
      console.log('not updating');
    } else {
      this.setState({
        closedPeriod,
      }, this.validate);
    }
  }

  handleOnSave(e) {
    e.preventDefault();
    let {closedPeriod} = this.state;

    this.validate(() => {
      if(this.isValid()) {
        this.props.onSave(closedPeriod);
      }
    });
  }

  validate(afterValidate){
    let {closedPeriod} = this.state;
    let {closedPeriods} = this.props;

    let validationMessages = {};
    let dateFrom = moment(closedPeriod.dateFrom);
    let dateTo = moment(closedPeriod.dateTo);

    if(isNullEmptyOrWhitespace(closedPeriod.description)){
      validationMessages.description = 'Please enter a description';
    } else if (closedPeriod.description.length > 1000) {
      validationMessages.description = 'Please enter a description less than 1000 characters';
    }

    if(moment(closedPeriod.dateFrom).isBefore(moment(), 'day') && closedPeriod.id <= 0) {
      if (!dateFrom.isSameOrAfter(moment(), 'day')) {
        validationMessages.dateFrom = 'Please enter a date after today';
      }
    }
    if(dateTo.isBefore(dateFrom, 'day') ){
      validationMessages.dateTo = 'Please enter a date after the from date';
    } else if (!dateTo.isSameOrAfter(moment(), 'day')) {
      validationMessages.dateTo = 'Please enter a date after today';
    }

    if(Object.keys(validationMessages).length === 0) {
      //check if the current period is between any existing
      let overLapping = closedPeriods.filter(x => {
        let existingFrom = moment(x.dateFrom);
        let existingTo = moment(x.dateTo);

        if(x.id === closedPeriod.id){
          return false;
        }

        if (dateTo.isSameOrBefore(existingTo, 'day') && dateTo.isSameOrAfter(existingFrom, 'day')) {
          return true;
        }

        if (dateFrom.isSameOrBefore(existingTo, 'day') && dateFrom.isSameOrAfter(existingFrom, 'day')) {
          return true;
        }
        return false;
      });

      if(overLapping.length > 0){
        validationMessages.overLapping = 'This closed period overlaps an existing period';
      }
    }

    this.setState({validationMessages}, afterValidate);
  }

  isValid(){
    let {validationMessages} = this.state;

    return Object.keys(validationMessages).length === 0;
  }

  render() {
    let {isOpen, onCancel} = this.props;
    let {closedPeriod, validationMessages} = this.state;
    let isValid = this.isValid();

    return !IsNullOrUndefined(closedPeriod) ? (<div>
      <Modal
          style={{maxWidth: '650px'}}
          isOpen={isOpen}
          toggle={onCancel}
      >
        <ModalHeader>
          {closedPeriod.id <= 0 ? 'New' : 'Edit'} Closed Period
        </ModalHeader>
        <ModalBody>
          <div className="form-horizontal col-12">

            <TextBoxControl
                name={'description'}
                labelText={'Description'}
                value={closedPeriod.description}
                onChange={this.handleFieldChange}
                validationMessages={validationMessages}
            />

            <CheckBoxControl
                name={'isAnnual'}
                value={closedPeriod.isAnnual}
                onChange={this.handleFieldChange}
                labelText={'Is Annual'}
            />

            <div className="form-group row">
              <label className="col-md-2 col-xs-3 col-sm-3 form-control-label" htmlFor={'dateFrom'}>From: </label>
              <div className="col-md-8 col-xs-10 col-sm-10 ">
                <DatePicker
                    onChange={(date) => this.handleOnChangeDate(date, 'dateFrom')}
                    //value={closedPeriod.dateFrom}
                    //openToDate={moment(closedPeriod.dateFrom)}
                    placeholderText="Date From"
                    locale="en-au"
                    readOnly={false}
                    popperPlacement="bottom-end"
                    popperModifiers={{
                      offset: {
                        enabled: true,
                        offset: '5px, 10px'
                      },
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                        boundariesElement: 'viewport'
                      }
                    }}
                    className="form-control"
                    monthsShown={2}
                    minDate={moment()}
                    selected={moment(closedPeriod.dateFrom)}
                    selectsStart
                    startDate={moment(closedPeriod.dateFrom)}
                    endDate={moment(closedPeriod.dateTo)}
                    onChangeRaw={event => {
                      let date = moment(event.target.value);
                      if(date.isValid()){
                        this.handleOnChangeDate(date, 'dateFrom');
                      }
                    }}
                    disabled={moment(closedPeriod.dateFrom).isBefore(moment(), 'day')}
                />
                {!IsNullOrUndefined(validationMessages['dateFrom']) && <div style={{color: 'red'}}>{validationMessages['dateFrom']}</div> }
              </div>
            </div>

            <div className="form-group row">
              <label className="col-md-2 col-xs-3 col-sm-3 form-control-label" htmlFor={'dateFrom'}>To: </label>
              <div className="col-md-8 col-xs-10 col-sm-10 ">
                <DatePicker
                    onChange={(date) => this.handleOnChangeDate(date, 'dateTo')}
                    //value={closedPeriod.dateTo}
                    //openToDate={moment(closedPeriod.dateTo)}
                    placeholderText="Date To"
                    locale="en-au"
                    readOnly={false}
                    popperPlacement="bottom-end"
                    popperModifiers={{
                      offset: {
                        enabled: true,
                        offset: '5px, 10px'
                      },
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                        boundariesElement: 'viewport'
                      }
                    }}
                    className="form-control"

                    monthsShown={2}
                    selected={moment(closedPeriod.dateTo)}
                    selectsEnd
                    startDate={moment(closedPeriod.dateFrom)}
                    endDate={moment(closedPeriod.dateTo)}
                    minDate={moment(closedPeriod.dateFrom)}
                    onChangeRaw={event => {
                      let date = moment(event.target.value);
                      if(date.isValid()){
                        this.handleOnChangeDate(date, 'dateTo');
                      }
                    }}
                />
                {!IsNullOrUndefined(validationMessages['dateTo']) && <div style={{color: 'red'}}>{validationMessages['dateTo']}</div> }
                {!IsNullOrUndefined(validationMessages['overLapping']) && <div style={{color: 'red'}}>{validationMessages['overLapping']}</div> }
              </div>
            </div>

          </div>
        </ModalBody>
        <ModalFooter>
          {isValid && <Button color={'default'} onClick={this.handleOnSave}>Save</Button> }
          <Button color={'secondary'} onClick={(e)=> onCancel()}>Back</Button>
        </ModalFooter>
      </Modal>

    </div>) : null;
  }
}

ClosedPeriodView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closedPeriod: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  closedPeriods: PropTypes.array.isRequired,
};

export default ClosedPeriodView;